<template>
  <div>
    <queries-table ref="table" :url="indexUrl">
      <template v-slot:buttons>
        <el-tooltip content="Vacuum" placement="top" effect="light">
          <button class="btn btn-purple" v-if="canVacuum" @click="showVacuumDialog">
            <i class="fas fa-broom"></i>
          </button>
        </el-tooltip>
      </template>
    </queries-table>
    <vacuuming-dialog ref="vacuumDialog" :url="vacuumUrl" @vacuum="afterVacuum"></vacuuming-dialog>
  </div>
</template>

<script>
import QueriesTable from './table';
import VacuumingDialog from './vacuum-dialog';

export default {
  components: {
    QueriesTable,
    VacuumingDialog,
  },

  props: {
    indexUrl: null,
    canVacuum: {
      type: Boolean,
      default: false
    },
    vacuumUrl: String,
  },

  methods: {
    /**
     * @return {undefined}
     */
    showVacuumDialog() {
      this.$refs.vacuumDialog.show();
    },

    /**
     * @return {undefined}
     */
    afterVacuum() {
      this.$refs.table.refresh();
    },
  },
}
</script>
